import React from 'react'
import { useTranslation } from 'react-i18next'

import { useTimer } from 'hooks/useTimer'

const NoContentFeedback: React.FC<{ timeout: number }> = ({ timeout }) => {
  const { t } = useTranslation(['surprise', 'common'])
  const [time] = useTimer(timeout)

  return (
    <div>
      <div>{t('feedbacks.no-content-on-fetch-next')}</div>
      <div>
        {t('feedbacks.wait-thirty-seconds', { count: Math.floor(time / 1000) })}
      </div>
    </div>
  )
}

export { NoContentFeedback }
